import * as Vec3 from 'gl-vec3';
import * as Vec2 from 'gl-vec2';

import { lerp, lerpAngle } from './lerp';

const makeJumpingState = (getFloorIntersection, getWallIntersection) => {
  const initialState = {
    skidJump: false,
  };
  
  const update = (state, dt, { movement, jump }) => {
    const lastPosition = state.position;
    state.position = Vec3.clone(state.position);
    state.velocity = Vec3.clone(state.velocity);
    let floatBonus = 0;
    
    // apply gravity
    state.velocity[1] -= 55 * dt;
    
    // hold jump in the air to glide
    /*
    const floatSpeed = Math.min(-20 + Vec2.length([state.velocity[0], state.velocity[2]]) * 2, -1);
    if (jump && state.velocity[1] <= floatSpeed) {
      state.velocity[1] = Math.min(floatSpeed, state.velocity[1] + 75*dt);
      floatBonus = floatSpeed - state.velocity[1];
      if (floatSpeed - state.velocity[1] < 1) {
        state.jumped = true;
      }
      const targetFacing = Math.atan2(state.velocity[0], state.velocity[2]);
      state.facing = lerpAngle(state.facing, targetFacing, 0.05, dt*60);
    }
    */
    
    // apply accel but keep a max horizontal speed
    if (Vec2.length(movement) > 0.1) {
      const velocity2d = Vec2.fromValues(state.velocity[0], state.velocity[2]);
      const flatSpeed = Vec2.length(velocity2d);
      const maxSpeed = Math.max(flatSpeed, 6 + floatBonus);
      if (flatSpeed >= maxSpeed) {
        Vec2.scale(velocity2d, velocity2d, (flatSpeed - 14*Vec2.length(movement)*dt) / flatSpeed);
      }
      Vec2.scaleAndAdd(velocity2d, velocity2d, movement, (15 + floatBonus) * dt);
      if (Vec2.length(velocity2d) > maxSpeed) {
        Vec2.normalize(velocity2d, velocity2d);
        Vec2.scale(velocity2d, velocity2d, maxSpeed);
      }

      // switch back to 3d
      state.velocity[0] = velocity2d[0];
      state.velocity[2] = velocity2d[1];
    }
    
    // hold jump to float higher
    if (jump && state.jumped && state.velocity[1] > 5) {
      state.velocity[1] += 40 * dt;
    }
    
    // reset the jump button
    if (!jump && state.velocity[1] <= 0) {
      state.jumped = false;
    }

    // jumping legs animation
    state.walk = lerpAngle(state.walk, 1.5 * Math.PI, 0.1, dt*60);
    state.walkScale = lerp(state.walkScale, Math.min(Math.max(state.velocity[1] / 10, -1), 1), 0.1, dt*60);
    
    Vec3.scaleAndAdd(state.position, state.position, state.velocity, dt);
    
    const wall = getWallIntersection(Vec3.add([], state.position, [0, 2, 0]), 0.5);
    if (wall.hit && wall.distance < 1) {
      Vec3.scaleAndAdd(state.position, state.position, wall.normal, 1-wall.distance);
      const bounce = false;
      if (bounce) {
        Vec3.scaleAndAdd([], state.velocity, wall.normal, -2 * Vec3.dot(state.velocity, wall.normal));
      } else {
        const scale = Math.max(-Math.cos(Vec3.angle(state.velocity, wall.normal)), 0);
        Vec3.scaleAndAdd([], state.velocity, wall.normal, Vec3.length(state.velocity) * scale);
      }
    }
    
    const floor = getFloorIntersection(state.position, 2);
    if (floor.hit) {
      if (floor.distance <= 0 && state.velocity[1] < 0) {
        Vec3.copy(state.position, floor.hit);
        state.mode = 'grounded';
      }
      state.shadowNormal = floor.normal;
      state.shadowDistance = state.position[1] - floor.hit[1];
    } else {
      Vec3.set(state.velocity, -state.velocity[0], Math.min(Math.max(state.velocity[1], -20), 5), -state.velocity[2]);
      Vec3.copy(state.position, lastPosition);
    }
    
    return state;
  };
  
  return { initialState, update };
}

export default makeJumpingState;